<template>
  <div style="background-color: #f2f2f2;height: 100%;">
    <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
      服务对象列表
    </div>
    <div style="padding: 20px;">
      <div>
        <el-row>

<!--          <el-button plain type="primary"  @click.native="toggleModalAdd">添加</el-button>-->

          <div style="float:right">
            <el-input placeholder="请输入姓名" v-model="name" maxlength="11" clearable
                      style="width:200px;margin-right:10px"></el-input>
            <el-input placeholder="请输入手机号" v-model="phone" maxlength="11" clearable
                      style="width:200px;margin-right:10px"></el-input>
            <el-select v-model="status" placeholder="请选择状态"
                           style="width:200px;margin-right:10px">
                  <el-option
                      v-for="item in statusList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
            <el-button type="primary" icon="el-icon-search" @click="getList">搜索</el-button></div>
        </el-row>

        <div style="clear: both;"></div>
      </div>

      <div style="height: 10px;"></div>

      <div>
        <template>

          <el-table :data="tableData"
                    :height="th"
                    border
                    style="width: 100%;"
                    v-loading="loading"
                    :row-class-name="tableRowClassName">
           <el-table-column prop="name" fixed="left" label="姓名" ></el-table-column>
                        <el-table-column prop="phone" label="手机号" ></el-table-column>
                        <el-table-column prop="createTime" :formatter="getTime" label="注册时间" ></el-table-column>
                        <el-table-column prop="userStatus" :formatter="statusTitle" label="状态" ></el-table-column>


            <!--            <el-table-column fixed="right" label="操作" width="280">-->
            <!--              <template slot-scope="scope">-->
            <!--                <el-button type="primary" size="small" @click="handleEdit(scope.row)">编辑 </el-button>-->
            <!--                <el-button type="success" size="small" @click="DeviceManage(scope.$index, scope.row)">设备管理 </el-button>-->
            <!--                <el-button type="info" size="small" @click="handleInfo(scope.row)">老人档案 </el-button>-->
            <!--              </template>-->
            <!--            </el-table-column>-->

          </el-table>

          <div style="text-align: left;background-color: #fff;padding: 10px;">
            <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）
            </div>
            <div style="float: left;">
              <el-pagination
                  background
                  layout="prev, pager, next"
                  :total="totalItems"
                  :page-size="20"
                  :current-page.sync="currentPage"  @current-change="current_change">
              </el-pagination>
            </div>
            <div style="clear: both;"></div>
          </div>


        </template>
      </div>

    </div>
    <!--    <Edit ref="myEdit" v-show="showModalEdit" v-on:closeEdit="closeEdit" v-on:getList="getList"></Edit>-->
    <!--    <Add ref="myAdd" v-show="showModalAdd" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>-->
    <!--    <OldManFile ref="myOldManFile" v-show="showModalOldManFile" v-on:closeInfo="closeOldManFile" v-on:getList="getList"></OldManFile>-->
    <!--    <PageForDevice ref="myPageForDevice" v-show="showModalDevice"  v-on:closeDevice="closeDevice"  v-on:getList="getList"   ></PageForDevice>-->
  </div>
</template>

<script>

import {timeStr, timefilters} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import elderly from "@/common/status";
import {getStaffCode} from "@/utils/auth";


export default {
  name: "Role",
  data() {
    return {
      showModalDevice:false,
      censusRegister:'',
      loading: false,
      showModalAdd: false,
      showModalOldManFile: false,
      datetimerangeValue: '',
      showModalEdit: false,
      showModalSearch: false,
      tableData: null,
      totalItems: 0,
      pageSize: 20,
      currentPage: 1,
      th: 0,
      name: '',
      idCard: '',
      ctiyDate: [],
      elderlyType: elderly.serviceType,
      elderlyClassValue: [],
      nationValue: [],
      zoneValue: [],
      areaValue: [],
      zoneCode: '00000000-0000-0000-0000-000000000000',
      elderlyAllType: elderly,
      zoneProps: {
        emitPath: false,
        value: 'zoneCode',
        // 显示的文字字段名
        label: 'name',
        // 子层级字段名
        children: 'listZoneDTO'
      },
      phone: '',
      elderlyClassList:'',
      censusRegisterList:['城市','农村'],
      status:-1,
      statusList: [
        {
          value: -1, label: '全部状态'
        }, {
          value: 1, label: '正常'
        }, {
          value: 2, label: '禁用'
        }
      ],
    }
  },
  components: {

  },

  created() {

    this.init();
    this.th = this.$store.state.tableHeight;
  },

  watch: {
    //监听全局变量
    '$store.state.tableHeight': function (val) {
      this.th = val;
    },
  },
  methods: {
    init: function () {
      const end = new Date();
      const start = new Date(end - 1000 * 60 * 60 * 24 * 365);
      this.datetimerangeValue = [start, end];
      this.getList();
    },
    getZoneValue(val) {
      this.zoneCode = val
    },
    getTime(row,index,column){
      return timefilters(column)
    },
    tableRowClassName({row}) {
      const timeAudit = new Date(row.timeAudit);
      const end = new Date();
      const start = new Date(end - 1000 * 60 * 60 * 24 * 30);
      if (timeAudit >= start) {
        return 'success-row';
      }
      return '';
    },
    getAge(row) {
      var identityCard = row.idCard;

      var len = (identityCard + "").length;
      if (len == 0) {
        return 0;
      } else {
        if ((len != 15) && (len != 18))//身份证号码只能为15位或18位其它不合法
        {
          return 0;
        }
      }
      var strBirthday = "";
      if (len == 18)//处理18位的身份证号码从号码中得到生日和性别代码
      {
        strBirthday = identityCard.substr(6, 4) + "/" + identityCard.substr(10, 2) + "/" + identityCard.substr(12, 2);
      }
      if (len == 15) {
        strBirthday = "19" + identityCard.substr(6, 2) + "/" + identityCard.substr(8, 2) + "/" + identityCard.substr(10, 2);
      }
      //时间字符串里，必须是“/”
      var birthDate = new Date(strBirthday);
      var nowDateTime = new Date();
      var age = nowDateTime.getFullYear() - birthDate.getFullYear();
      //再考虑月、天的因素;.getMonth()获取的是从0开始的，这里进行比较，不需要加1
      if (nowDateTime.getMonth() < birthDate.getMonth() || (nowDateTime.getMonth() == birthDate.getMonth() && nowDateTime.getDate() < birthDate.getDate())) {
        age--;
      }
      return age;

    },
    download() {
      this.$confirm('是否导出当前列表?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.showModal = true
        var that = this
        var zoneCode = '00000000-0000-0000-0000-000000000000'
        if (this.zoneCode) {
          zoneCode = this.zoneCode
        }
        this.$axios.get(this.$shopUrl + 'ExportOldest/GetElderlyStatistics', {
          responseType: 'blob',
          params: {
            timeStr: timeStr,
            sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
            staffCode: getStaffCode(),
            startTime: timefilters(this.datetimerangeValue[0]),
            endTime: timefilters(this.datetimerangeValue[1]),
            zoneCode: zoneCode,
          }
        }).then(
            (response) => {
              if (response.data.type === 'application/json') {
                console.log(response)
                var datas = JSON.parse(response.data.data);
                console.log(datas);
                this.$message({type: 'info', message: '暂无数据'});
                that.showModal = false;
              } else {
                let fileName = '合肥市高龄津贴年审表.xlsx';
                that.file(response, fileName)
                that.showModal = false
              }
            }
        )
        this.dialogFormVisible = false
      }).catch(e => e)
    },
    file(response, fileName) {
      let blob = new Blob([response.data]);
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, fileName);
      } else {
        let elink = document.createElement("a");
        elink.download = fileName;
        elink.style.display = "none";
        elink.href = URL.createObjectURL(blob)
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href);
        document.body.removeChild(elink);
      }
    },
    handleEdit(row) {
      this.$refs.myEdit.init(row);
      this.showModalEdit = !this.showModalEdit;
    },
    handleInfo(row) {
      this.$refs.myOldManFile.init(row);
      this.showModalOldManFile = !this.showModalOldManFile;
    },
    toggleModalAdd: function () {
      this.showModalAdd = !this.showModalAdd;
      this.$refs.myAdd.init();
    },
    closeAdd: function () {
      this.showModalAdd = !this.showModalAdd;
    },
    closeOldManFile(){
      this.showModalOldManFile = !this.showModalOldManFile;
    },
    toggleModalSearch: function () {
      this.showModalSearch = !this.showModalSearch;
      this.$refs.mySearch.init();
    },
    closeSearch: function () {
      this.showModalSearch = !this.showModalSearch;
    },
    toggleModalEdit: function () {
      this.showModalEdit = !this.showModalEdit;
    },
    closeEdit: function () {
      this.showModalEdit = !this.showModalEdit;
    },
    closeDevice:function (){
      this.showModalDevice = !this.showModalDevice;
    },

    current_change: function (currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },

    DeviceManage(index, row){
      this.$refs.myPageForDevice.init(row);
      this.showModalDevice = !this.showModalDevice;
    },

    getList() {
      this.loading=true;
      this.$axios({
        method: 'post',
        url: this.$shopUrl + "Elderly/PageForBusinessAdm",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
          pageIndex: this.currentPage,
          pageSize: this.pageSize,
          phone: this.phone,
          name:this.name,
          status:this.status
        }
      }).then((response) => {
        if (response.data.error == 0) {
          this.loading=false;
          this.tableData = response.data.data.list;
          this.totalItems = response.data.data.total;
        } else if (response.data.error == 1) {
          this.loading=false;
          this.$message.error(response.data.message)
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    statusTitle(row) {
      if (row.userStatus == 1) {
        return "正常";
      }
      if (row.userStatus == 2) {
        return "禁用";
      }
      return "其它";
    },
    elderlyTypes(row) {
      if (row.elderlyType == 0) {
        return "政府购买服务";
      }
      if (row.elderlyType == 1) {
        return "有偿服务";
      }
      if (row.elderlyType == -1) {
        return "";
      }
      return "其它";
    },
    politics(row) {
      return this.allStatus(row.politicsStatus, elderly.politicalOutlook);
    },
    censusRegisters(row) {
      return this.allStatus(row.censusRegister, elderly.natureHRegistrater);
    },
    educations(row) {
      return this.allStatus(row.education, elderly.education);
    },
    allStatus(row, status) {
      for (var i in status) {
        if (status[i].value == row) {
          return status[i].label
        }
      }
      return "其它";
    },
    elderlyClass(row){
      for (var i=0;i<this.elderlyClassList.length;i++){
        if(row.elderlyClass===this.elderlyClassList[i].value){
          return this.elderlyClassList[i].name;
        }
      }
    },

  }
}
</script>
<style>
.el-table .success-row {
  background: #f0f9eb;
}
</style>
<style scoped>

</style>
